import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { languages } from "../constants/languages";

const styles = (theme) => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    width: "95%",
    maxWidth: 400,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 90,
  }),
  alert: {
    width: "95%",
    maxWidth: 400,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 20,
  },
  textField: {
    margin: theme.spacing(1),
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  headline: {
    margin: theme.spacing(1),
  },
  link: {
    display: "block",
    margin: theme.spacing(1),
  },
});

const Login = (props) => {
  const { classes } = props;
  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Typography variant="h5" component="h3" className={classes.headline}>
          {languages.login.login}
        </Typography>
        <form>
          <TextField
            type="email"
            label={languages.login.email}
            value={props.email}
            onChange={props.handleEmailChange}
            className={classes.textField}
          />
          <TextField
            type="password"
            label={languages.login.password}
            value={props.password}
            onChange={props.handlePasswordChange}
            className={classes.textField}
          />
          <div className={classes.textField} style={{ color: "red" }}>
            {props.errorMessage}
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={props.handleLogin}
          >
            {languages.login.login}
          </Button>
        </form>
        <Link to="/forgotpassword" className={classes.link}>
          {languages.login.forgotPassword}
        </Link>
        <div className={classes.link}>
          {languages.login.noAccount + " "}
          <Link to="/signup">{languages.login.signup}</Link>
        </div>
      </Paper>
      {/* <div className={classes.alert}>
        <Alert severity="warning" style={{ marginBottom: 10 }}>
          {languages.login.outage}
        </Alert>
      </div> */}
    </div>
  );
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
